// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldLabel_root__12W9Y","description":"FieldLabel_description__3TBnF"};